import React from 'react';
import TextField from '@mui/material/TextField';
import setSearchTitleAction from '../../redux/actions/searchReferenceActions/actionSearchTitle';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';

const StyledTextField = styled(TextField)({
    '& .MuiOutlinedInput-notchedOutline': {
      '&:hover': {
        borderColor: "rgb(0,191,255)",
      },
      '&.Mui-focused': {
        borderColor: "rgb(47, 79, 79)",
      },
    },
    '& .Mui-focused': {
      color: 'white',
    },
    width: 300,
    marginTop: 10,
    fontSize: 30,
    backgroundColor: 'rgba(19, 174, 236, 0.54)',
    fontWeight: 'bold'
  });

class SearchTitleForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = { searchTitle: ''};
        this.handleChange = this.handleChange.bind(this);
        this.props.setSearchTitleFunction('');
    }

    handleChange(event) {
        this.setState({ searchTitle: event.target.value }, () => {
            this.props.setSearchTitleFunction(this.state.searchTitle);
        });
    };

    render() {
        const { classes } = this.props;
        const { t } = this.props;
        return (
            <div>
                <StyledTextField classes={classes} label={t('create_ref.title')} onChange={this.handleChange} variant="outlined" style={{ width: 300, marginTop: 10, fontSize: 30, backgroundColor: 'rgba(19, 174, 236, 0.54)' }}
                 />
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
      setSearchTitleFunction: searchTitle => {
        dispatch(setSearchTitleAction(searchTitle));
      }
    }
  }

export default connect(null,mapDispatchToProps)(withTranslation()(SearchTitleForm));